import {createSlice} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import FormHelper from '../../utils/forms'
import Resource from '../../api/resource'
import QueryHelper from '../../utils/query'
import Statistics from '../../api/statistics'
import {getAllLimitUsages} from '../auth'
import statusCodes from '../../utils/http'
import {routes} from '../../routes'
import NavigationHelper from '../../utils/navigation'

export const heartbeatsSlice = createSlice({
    name: 'heartbeats',
    initialState: {
        rulesets: []
    },
    reducers: {
        setRulesets: (state, {payload}) => {
            state.rulesets = payload
        }
    }
})

export const {
    setRulesets
} = heartbeatsSlice.actions

export default heartbeatsSlice.reducer

export const addJob = (values, setFieldError) => {
    return async(dispatch) => {
        try {
            const {data} = await Resource.addHeartbeat(values)
            await dispatch(getAllLimitUsages())
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const updateJob = (id, values, setFieldError) => {
    return async(dispatch) => {
        try {
            const {data} = await Resource.updateHeartbeat(id, values)
            await dispatch(getAllLimitUsages())
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const deleteJob = (selectedJobs) => {
    return async(dispatch) => {
        try {
            const query = QueryHelper.makeQueryFromArray('id', selectedJobs)
            const {data} = await Resource.deleteHeartbeats(query)
            toast.success(data?.message)
            await dispatch(getAllLimitUsages())
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }
}

export const getJobs = () => {
    return async(dispatch, getState) => {
        const services = getState()?.resources?.services
        try {
            const res = await Promise.all(services.map(item => Resource.getHeartbeats(item?.value)))
            let data = res?.map(item => {
                return item?.data?.data?.heartbeats
            })
            const heartbeats = []
            data?.map(item => {
                item && heartbeats.push(item)
            })
            return heartbeats?.flat(1) || []
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const getJobStatistics = (id, query, navigate) => {
    return async() => {
        try {
            const {data} = await Statistics.getJobStatistics(id, query)
            return data?.data?.statistics
        } catch (e) {
            if (statusCodes.SpecialErrors.includes(e?.response?.status)) {
                navigate(NavigationHelper.getLocalizedPath(routes.not_found.paths))
                return
            }
            toast.error(e?.response?.data?.message)
        }
    }
}

export const getJob = (id, navigate) => {
    return async() => {
        try {
            const {data} = await Resource.getHeartbeat(id)
            return data?.data?.heartbeat
        } catch (e) {
            if (statusCodes.SpecialErrors.includes(e?.response?.status)) {
                navigate(NavigationHelper.getLocalizedPath(routes.not_found.paths))
                return
            }
            toast.error(e?.response?.data?.message)
        }
    }
}

export const getJobEvents = (id, navigate, lastReceivedAt = '', limit = 10) => {
    return async() => {
        try {
            const queryParams = `?last_received_at=${lastReceivedAt}&limit=${limit}`
            const {data} = await Statistics.getJobEvents(id, queryParams)
            return {
                data: data?.data?.events,
                count: data?.meta?.count
            }
        } catch (e) {
            if (statusCodes.SpecialErrors.includes(e?.response?.status)) {
                navigate(NavigationHelper.getLocalizedPath(routes.not_found.paths))
                return
            }
            toast.error(e?.response?.data?.message)
        }
    }
}
